module.exports = {
	"ha": "fha",
	"id": 5.6,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.6</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by PWID Status, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 99.23664122137404,
						"dataLabels": {
							"enabled": true,
							"format": "390"
						}
					},
					{
						"y": 96.69211195928753,
						"dataLabels": {
							"enabled": true,
							"format": "380"
						}
					},
					{
						"y": 94.65648854961832,
						"dataLabels": {
							"enabled": true,
							"format": "372"
						}
					},
					{
						"y": 83.96946564885496,
						"dataLabels": {
							"enabled": true,
							"format": "330"
						}
					},
					{
						"y": 61.32315521628499,
						"dataLabels": {
							"enabled": true,
							"format": "241"
						}
					},
					{
						"y": null
					},
					{
						"y": 98.64864864864865,
						"dataLabels": {
							"enabled": true,
							"format": "1314"
						}
					},
					{
						"y": 97.5975975975976,
						"dataLabels": {
							"enabled": true,
							"format": "1300"
						}
					},
					{
						"y": 95.64564564564564,
						"dataLabels": {
							"enabled": true,
							"format": "1274"
						}
					},
					{
						"y": 90.16516516516516,
						"dataLabels": {
							"enabled": true,
							"format": "1201"
						}
					},
					{
						"y": 74.92492492492492,
						"dataLabels": {
							"enabled": true,
							"format": "998"
						}
					},
					{
						"y": null
					},
					{
						"y": 93.49904397705545,
						"dataLabels": {
							"enabled": true,
							"format": "489"
						}
					},
					{
						"y": 78.77629063097514,
						"dataLabels": {
							"enabled": true,
							"format": "412"
						}
					},
					{
						"y": 76.48183556405354,
						"dataLabels": {
							"enabled": true,
							"format": "400"
						}
					},
					{
						"y": 70.93690248565966,
						"dataLabels": {
							"enabled": true,
							"format": "371"
						}
					},
					{
						"y": 59.08221797323135,
						"dataLabels": {
							"enabled": true,
							"format": "309"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -0.7633587786259555,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.564102564102566,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.1052631578947323,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.290322580645162,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.969696969696965,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.3513513513513487,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.0654490106544956,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.0000000000000018,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.7299843014128715,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.902581182348044,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.500956022944548,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.746421267893663,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.9126213592232997,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.250000000000001,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.71159029649596,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "PWID<br>n=393"
			},
			{
				"x": 9,
				"text": "Non-PWID<br>n=1332"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=523"
			}
		],
		"dataTable": {
			"IDU": [
				393,
				390,
				380,
				372,
				330,
				241
			],
			"Non-IDU": [
				1332,
				1314,
				1300,
				1274,
				1201,
				998
			],
			"Unknown": [
				523,
				489,
				412,
				400,
				371,
				309
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_6.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_6.json
// module id = 205
// module chunks = 0